import { createSelector } from '@ngrx/store';
import { lombardFeature } from './lombard.reducer';

export const selectShouldDisplayConfirmationModal = createSelector(
  lombardFeature.selectLombard,
  (lombard) => !!lombard?.creditToBeConfirmedExists,
);

export const selectShouldDisplayTeaser = createSelector(
  lombardFeature.selectLombard,
  lombardFeature.selectHasDismissedTeaserRecently,
  (lombard, hasDismissedRecently) => !!lombard?.showLombardTeaser && !hasDismissedRecently,
);
